type RecruiterDetail = {
  recruiterId: number | string;
  name: string;
  organisationId: number | string;
  organisationName: string;
  designation: string;
  email: string;
  domain: string;
  pictureLink: string;
  profileUrl: string;
};

type RecAction = {
  recruiterId: number | string;
  actionId: number | string;
  date: number | string;
};

type JobDetail = {
  id: number | string;
  title: string;
  min: number;
  max: number;
  location: any[];
  jobUrl: string;
  categoryId: number;
  functionalArea: number;
  createdTime: number | string;
  minSal?: number;
  maxSal?: number;
  hideSal?: boolean;
};

export type AppliedTileProps = {
  remSlots?: number;
  slotId?: number;
  calId?: number;
  id: number | string;
  applicantId: number | string;
  applicationId: number | string;
  applicationDate: number | string;
  recruiterDetail: RecruiterDetail;
  recruiterAction: RecAction[];
  jobDetail: JobDetail;
  followUp: {
    status: boolean;
    date: number;
  };
  interviewTime?: string;
  interviewDate?: string;
  hasfollowup: number;
  views: number;
  app_count: number;
  unpublishInfo: any;
  confidential: number;
  app_status: number;
  recruiterActions: number;
  inviteStatus: number;
  recr_last_login?: any;
  lastActive: any;
  minSal?: number;
  maxSal?: number;
  hideSal?: boolean;
  isPro: Boolean;
  isStatusChangeCohortUser?: Boolean;

  setInsightsbox: React.Dispatch<React.SetStateAction<boolean>>;

  setshowProMembershipPrompt: React.Dispatch<React.SetStateAction<boolean>>;
  setShowFollowUpProMembershipPrompt: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setShowStatusProMembershipPrompt: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};

export type ScheduledComp = {
  date?: String;
  calId?: number;
  slotId?: number;
  remSlots?: number;
};

export type LockedStatusProp = {
  setShowStatusProMembershipPrompt: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};
export const RECRUITER_ACTION_TEXT: {[key: number]: string} = {
  0: 'APPLIED/SENT',
  1: 'SHORTLISTED',
  2: 'NOT SUITABLE',
  3: 'SAVED FOR FUTURE',
  4: 'VIEWED',
  5: 'DOWNLOADED',
  7: 'CONTACT VIEWED',
  101: 'YOUR STATUS HAS BEEN CHANGED',
  9: 'ROUND ZERO VIEWED',
};
